import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import SparkMD5 from 'spark-md5'
import { fetchPresignedS3Url } from '../actions/configurationActions'

interface S3FileUploaderProps {
  existingKey?: string | null
  onUploadComplete: (key: string) => void
  onRemove: () => void
}

const S3FileUploader: React.FC<S3FileUploaderProps> = ({
  existingKey,
  onUploadComplete,
  onRemove,
}) => {
  const dispatch = useDispatch()
  const [isUploading, setUploading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return
    setUploading(true)
    setError(null)
    try {
      const arrayBuffer = await file.arrayBuffer()
      const hexHash = SparkMD5.ArrayBuffer.hash(arrayBuffer)
      const base64Hash = btoa(
        hexHash
          .match(/\w{2}/g)!
          .map((a) => String.fromCharCode(parseInt(a, 16)))
          .join('')
      )
      const { url, key } = (await dispatch(
        fetchPresignedS3Url(file.name, file.type, base64Hash)
      )) as any
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type,
          'Content-MD5': base64Hash,
        },
        body: file,
      })
      if (!response.ok)
        throw new Error(`Upload failed with status ${response.status}`)
      onUploadComplete(key)
    } catch (err: any) {
      console.error(err)
      setError(err.message || 'Upload error')
    } finally {
      setUploading(false)
    }
  }

  return (
    <div>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={isUploading}
      />
      {existingKey && (
        <button type="button" onClick={onRemove}>
          Remove File
        </button>
      )}
      {isUploading && <span>Uploading…</span>}
      {error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  )
}

export default S3FileUploader
